import { render } from "./Career.vue?vue&type=template&id=2c632134&scoped=true"
import script from "./Career.vue?vue&type=script&lang=js"
export * from "./Career.vue?vue&type=script&lang=js"

import "./Career.vue?vue&type=style&index=0&id=2c632134&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c632134"]])

export default __exports__